import { render } from "./AsNotice.vue?vue&type=template&id=5e31dbfd&ts=true"
import script from "./AsNotice.vue?vue&type=script&lang=ts"
export * from "./AsNotice.vue?vue&type=script&lang=ts"

import "./AsNotice.vue?vue&type=style&index=0&id=5e31dbfd&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__